const BASE = process.env.REACT_APP_ACTOR_API_URL || 'http://localhost:3001';

async function call(path, options = {}, token, userId) {
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token  ? { Authorization: `Bearer ${token}` } : {}),
      ...(userId ? { 'x-user-id': userId } : {}),
      ...options.headers,
    },
    ...options,
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Request failed');
  return json.data;
}

export const createApiKey = (name, token, userId) =>
  call('/api-keys', { method: 'POST', body: JSON.stringify({ name }) }, token, userId);

export const listApiKeys = (token, userId) =>
  call('/api-keys', {}, token, userId);

export const revokeApiKey = (id, token, userId) =>
  call(`/api-keys/${id}`, { method: 'DELETE' }, token, userId);
